<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <!-- Dados da ordem de serviço -->
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">
                {{
                  EhEdicao
                    ? "Editar Ordem de Serviço nº " + viewModel.number
                    : "Nova Ordem de Serviço"
                }}
              </strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-5">
                  <div class="form-group">
                    <label for>* Título</label>
                    <input
                      v-model="viewModel.title"
                      class="form-control"
                      type="text"
                      placeholder="Digite o título da ordem de serviço"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>Equipe</label>
                    <v-select
                      v-model="equipeSelecionada"
                      placeholder="Selecione a equipe"
                      :options="equipes"
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Data prevista</label>
                    <input
                      v-model="viewModel.scheduledDate"
                      class="form-control"
                      type="date"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-10 col-lg-9 col-xl-9">
                  <div class="form-group">
                    <label for>Descrição</label>
                    <textarea
                      v-model="viewModel.description"
                      class="form-control"
                      rows="2"
                      placeholder="Digite a descrição"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Busca de árvores -->
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">Buscar árvores</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Projeto</label>
                    <v-select
                      v-model="filtro.projects"
                      placeholder="Digite o nome do projeto"
                      :options="projetos"
                      multiple
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Origem</label>
                    <v-select
                      v-model="filtro.origins"
                      placeholder="Digite o nome da origem"
                      :options="origens"
                      multiple
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Situação</label>
                    <v-select
                      v-model="filtro.status"
                      placeholder="Digite o nome da situação"
                      :options="situacoes"
                      multiple
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>GAAU</label>
                    <v-select
                      v-model="filtro.priorities"
                      placeholder="Digite o nome do GAAU"
                      :options="prioridades"
                      multiple
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>Recomendação de Manejo</label>
                    <v-select
                      v-model="filtro.managers"
                      placeholder="Digite o nome do manejo"
                      :options="['Todos', ...manejos]"
                      multiple
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <button
                    class="btn btn-secondary mt-4"
                    type="button"
                    @click="Buscar(1)"
                  >
                    Filtrar
                  </button>
                </div>
              </div>

              <div v-if="buscando" class="loading-container">
                <RotateSquare
                  class="loading-position animated fadeIn"
                  size="40px"
                ></RotateSquare>
              </div>
              <div v-else-if="resultados.length > 0">
                <div class="d-flex mb-2">
                  <button
                    class="btn btn-primary"
                    type="button"
                    :disabled="selecionadas.length === 0"
                    @click="AdicionarSelecionadas"
                  >
                    Adicionar selecionadas ({{ selecionadas.length }})
                  </button>
                </div>
                <b-table
                  :hover="true"
                  responsive
                  striped
                  :items="resultados"
                  :fields="fieldsBusca"
                  :per-page="itensPorPaginaBusca"
                >
                  <template v-slot:head(selecao)>
                    <b-form-checkbox
                      :checked="TodasSelecionadas"
                      @change="AlternarTodas"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(selecao)="data">
                    <b-form-checkbox
                      :checked="EstaSelecionada(data.item.gaauId)"
                      :disabled="JaNaOrdem(data.item.gaauId)"
                      @change="AlternarSelecao(data.item)"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(resultName)="data">
                    {{ data.item.resultName }}
                  </template>
                  <template v-slot:cell(managers)="data">
                    {{ (data.item.managers || []).join(", ") }}
                  </template>
                  <template v-slot:cell(alerta)="data">
                    <span
                      v-if="JaNaOrdem(data.item.gaauId)"
                      class="badge badge-secondary"
                    >
                      Já nesta OS
                    </span>
                    <span
                      v-else-if="data.item.hasOpenWorkOrder"
                      class="badge badge-warning"
                      title="Essa árvore já está em outra ordem de serviço aberta ou em execução."
                    >
                      Em outra OS
                    </span>
                  </template>
                </b-table>
                <b-pagination
                  v-model="paginaBusca"
                  :total-rows="totalBusca"
                  :per-page="itensPorPaginaBusca"
                  align="right"
                  size="md"
                  class="mt-2"
                ></b-pagination>
              </div>
              <h6 v-else-if="buscou" class="mt-3">
                Nenhuma árvore encontrada para os filtros informados.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <!-- Árvores da ordem de serviço -->
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">
                  Árvores da ordem de serviço ({{ viewModel.items.length }})
                </strong>
              </div>
            </header>
            <div class="card-body">
              <b-table
                :hover="true"
                responsive
                striped
                :items="viewModel.items"
                :fields="fieldsItens"
                show-empty
                empty-text="Nenhuma árvore adicionada."
              >
                <template v-slot:empty="scope">
                  <h6 class="mt-2">{{ scope.emptyText }}</h6>
                </template>
                <template v-slot:cell(order)="data">
                  <input
                    v-model.number="data.item.order"
                    class="form-control wd-80-px"
                    type="number"
                    min="1"
                  />
                </template>
                <template v-slot:cell(commonName)="data">
                  {{ data.item.commonName }}
                  <span
                    v-if="data.item.treeRemoved"
                    class="badge badge-danger ml-1"
                    title="Essa árvore foi excluída do cadastro depois da criação da OS."
                  >
                    Árvore excluída
                  </span>
                </template>
                <template v-slot:cell(managers)="data">
                  <v-select
                    v-model="data.item.managers"
                    placeholder="Selecione os manejos"
                    :options="OpcoesManejo(data.item)"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </template>
                <template v-slot:cell(acoes)="data">
                  <b-button
                    variant="danger"
                    size="sm"
                    title="Remover árvore"
                    :disabled="TemApontamento(data.item)"
                    @click="RemoverItem(data.index)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="btn-toolbar mb-3 ml-3" role="toolbar">
              <div class="btn-group" role="group">
                <button class="btn btn-success mr-2" type="submit">
                  Salvar
                </button>
              </div>
              <div class="btn-group" role="group">
                <button
                  class="btn btn-secondary"
                  type="reset"
                  @click="$router.go(-1)"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import WorkOrderService from "../../servico/WorkOrderService";
import TeamService from "../../servico/TeamService";
import ProjectService from "../../servico/ProjectService";
import GaauManagersEnum from "../../enums/GaauManagersEnum";
import WorkOrderStatus from "../../enums/WorkOrderStatusEnum";
import WorkOrderItemStatus from "../../enums/WorkOrderItemStatusEnum";
import DateTime from "../../util/DateTime";
import ApiError from "../../util/ApiError";

export default {
  name: "NewWorkOrder",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      buscando: false,
      buscou: false,
      manejos: GaauManagersEnum,
      projetos: [],
      equipes: [],
      equipeSelecionada: null,
      viewModel: {
        id: null,
        number: null,
        title: "",
        description: "",
        teamId: null,
        scheduledDate: null,
        status: WorkOrderStatus.Enum.Open,
        items: []
      },
      filtro: {
        projects: [],
        origins: [],
        status: [],
        priorities: [],
        managers: []
      },
      origens: [
        { id: "Nativa", label: "Nativa" },
        { id: "Exótica", label: "Exótica" },
        { id: "Exótica Invasora", label: "Exótica Invasora" }
      ],
      situacoes: [
        { id: "plantio", label: "Plantio" },
        { id: "viva", label: "Viva" },
        { id: "morta", label: "Morta" },
        { id: "destoca", label: "Destoca" }
      ],
      prioridades: [
        { id: 0, label: "Prioritário" },
        { id: 1, label: "Alto" },
        { id: 2, label: "Médio" },
        { id: 3, label: "Baixo" },
        { id: 4, label: "Todos" }
      ],
      resultados: [],
      selecionadas: [],
      paginaBusca: 1,
      totalBusca: 0,
      itensPorPaginaBusca: 20,
      fieldsBusca: [
        { key: "selecao", label: "", sortable: false },
        { key: "sequence", label: "Seq.", sortable: true },
        { key: "commonName", label: "Espécie", sortable: true },
        { key: "projectName", label: "Projeto", sortable: true },
        { key: "origin", label: "Origem", sortable: true },
        { key: "status", label: "Situação", sortable: true },
        { key: "resultName", label: "GAAU", sortable: true },
        { key: "managers", label: "Manejos recomendados", sortable: false },
        { key: "alerta", label: "", sortable: false }
      ],
      fieldsItens: [
        { key: "order", label: "Ordem", sortable: false },
        { key: "sequence", label: "Seq.", sortable: true },
        { key: "commonName", label: "Espécie", sortable: true },
        { key: "projectName", label: "Projeto", sortable: true },
        { key: "resultName", label: "GAAU", sortable: true },
        { key: "managers", label: "Manejos", sortable: false },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  computed: {
    EhEdicao() {
      return !!this.viewModel.id;
    },
    TodasSelecionadas() {
      let disponiveis = this.resultados.filter(
        (x) => !this.JaNaOrdem(x.gaauId)
      );
      return (
        disponiveis.length > 0 &&
        disponiveis.every((x) => this.EstaSelecionada(x.gaauId))
      );
    }
  },
  watch: {
    paginaBusca: function (val) {
      this.Buscar(val);
    }
  },
  created() {
    this.ObterProjetos();
    this.ObterEquipes();
    let id = this.$route.params.id;
    if (id) this.Obter(id);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();

      if (this.viewModel.items.length === 0) {
        this.$notify({
          data: ["Selecione ao menos uma árvore para a ordem de serviço."],
          type: "warn",
          duration: 5000
        });
        return;
      }

      if (this.EhEdicao) this.Editar();
      else this.Novo();
    },
    OpcoesManejo(item) {
      if (item.availableManagers && item.availableManagers.length > 0)
        return item.availableManagers;

      return GaauManagersEnum;
    },
    TemApontamento(item) {
      return !!item.status && item.status !== WorkOrderItemStatus.Enum.Pending;
    },
    EstaSelecionada(gaauId) {
      return this.selecionadas.indexOf(gaauId) >= 0;
    },
    JaNaOrdem(gaauId) {
      return this.viewModel.items.some((x) => x.gaauId === gaauId);
    },
    AlternarSelecao(arvore) {
      let indice = this.selecionadas.indexOf(arvore.gaauId);
      if (indice >= 0) this.selecionadas.splice(indice, 1);
      else this.selecionadas.push(arvore.gaauId);
    },
    AlternarTodas() {
      let disponiveis = this.resultados.filter(
        (x) => !this.JaNaOrdem(x.gaauId)
      );

      if (this.TodasSelecionadas) {
        disponiveis.forEach((arvore) => {
          let indice = this.selecionadas.indexOf(arvore.gaauId);
          if (indice >= 0) this.selecionadas.splice(indice, 1);
        });
        return;
      }

      disponiveis.forEach((arvore) => {
        if (!this.EstaSelecionada(arvore.gaauId))
          this.selecionadas.push(arvore.gaauId);
      });
    },
    AdicionarSelecionadas() {
      let adicionadas = 0;

      this.resultados.forEach((arvore) => {
        if (!this.EstaSelecionada(arvore.gaauId)) return;
        if (this.JaNaOrdem(arvore.gaauId)) return;

        this.viewModel.items.push({
          id: null,
          gaauId: arvore.gaauId,
          sequence: arvore.sequence,
          projectName: arvore.projectName,
          location: arvore.location,
          commonName: arvore.commonName,
          resultName: arvore.resultName,
          order: this.viewModel.items.length + 1,
          managers: [...(arvore.managers || [])],
          availableManagers: [...(arvore.managers || [])],
          status: WorkOrderItemStatus.Enum.Pending,
          treeRemoved: false
        });
        adicionadas++;
      });

      this.selecionadas = [];

      if (adicionadas > 0)
        this.$notify({
          data: [
            adicionadas === 1
              ? "1 árvore adicionada à ordem de serviço."
              : adicionadas + " árvores adicionadas à ordem de serviço."
          ],
          type: "success",
          duration: 3000
        });
    },
    RemoverItem(indice) {
      this.viewModel.items.splice(indice, 1);
    },
    MontarFiltro() {
      return {
        projects: (this.filtro.projects || [])
          .map((item) => item.id)
          .filter((id) => id && id !== this.$store.getters.emptyGuid),
        origins: (this.filtro.origins || [])
          .map((item) => item.id)
          .filter((id) => !!id),
        status: (this.filtro.status || [])
          .map((item) => item.id)
          .filter((id) => !!id),
        priorities: (this.filtro.priorities || []).map((item) => item.id),
        managers: (this.filtro.managers || []).filter((item) => item !== "Todos")
      };
    },
    Buscar(pagina) {
      this.buscando = true;
      this.buscou = true;

      WorkOrderService.SearchTrees(this.MontarFiltro(), pagina)
        .then((resposta) => {
          this.buscando = false;
          this.resultados = resposta.data.itens || [];
          this.totalBusca = resposta.data.total;
          this.paginaBusca = resposta.data.pagina;
          this.itensPorPaginaBusca = resposta.data.itensPorPagina;
        })
        .catch((erro) => {
          this.buscando = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    ObterProjetos() {
      ProjectService.GetVSelect("    ", true)
        .then((resposta) => {
          this.projetos = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    ObterEquipes() {
      TeamService.GetVSelect("")
        .then((resposta) => {
          this.equipes = resposta.data;
          this.SincronizarEquipe();
        })
        .catch((erro) => {
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    SincronizarEquipe() {
      if (!this.viewModel.teamId) return;

      let equipe = this.equipes.find((x) => x.id === this.viewModel.teamId);
      if (equipe) this.equipeSelecionada = equipe;
      else if (this.viewModel.teamName)
        this.equipeSelecionada = {
          id: this.viewModel.teamId,
          label: this.viewModel.teamName
        };
    },
    Obter(id) {
      this.loading = true;

      WorkOrderService.Get(id)
        .then((resposta) => {
          this.loading = false;

          if (WorkOrderStatus.IsFinal(resposta.data.status)) {
            this.$notify({
              data: [
                "Não é possível editar uma ordem de serviço concluída ou cancelada."
              ],
              type: "warn",
              duration: 5000
            });
            this.$router.push("/ordem-servico");
            return;
          }

          this.viewModel = resposta.data;
          if (!this.viewModel.items) this.viewModel.items = [];
          this.viewModel.items.forEach((item) => {
            item.availableManagers = [...(item.managers || [])];
          });
          this.viewModel.scheduledDate = DateTime.Format(
            resposta.data.scheduledDate
          );
          this.SincronizarEquipe();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    MontarItens() {
      return this.viewModel.items.map((item, indice) => {
        return {
          id: item.id || null,
          gaauId: item.gaauId,
          order: item.order || indice + 1,
          managers: item.managers || []
        };
      });
    },
    MontarViewModel() {
      return {
        title: this.viewModel.title,
        description: this.viewModel.description,
        teamId: this.equipeSelecionada ? this.equipeSelecionada.id : null,
        scheduledDate: this.viewModel.scheduledDate || null,
        items: this.MontarItens()
      };
    },
    Novo() {
      this.loading = true;

      let payload = this.MontarViewModel();
      payload.items = payload.items.map((item) => {
        return {
          gaauId: item.gaauId,
          order: item.order,
          managers: item.managers
        };
      });

      WorkOrderService.New(payload)
        .then(() => {
          this.loading = false;
          this.$router.push("/ordem-servico");
          this.$notify({
            data: ["Ordem de serviço cadastrada com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Editar() {
      this.loading = true;

      let payload = this.MontarViewModel();
      payload.id = this.viewModel.id;

      WorkOrderService.Edit(payload)
        .then(() => {
          this.loading = false;
          this.$router.push("/ordem-servico");
          this.$notify({
            data: ["Ordem de serviço editada com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>

<style scoped>
.wd-80-px {
  width: 80px;
}
</style>
